import { useState } from "react";
import { BsSun, BsMoon, BsList, BsX } from "react-icons/bs";
import { profileData } from "../data/profileData";

const Navbar = ({ isDarkMode, toggleTheme }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = () => setIsOpen(!isOpen);
	const closeMenu = () => setIsOpen(false);

	return (
		<header className="navbar">
			<div className="navbar-container">
				<div className="nav-brand">{profileData.name}</div>
				
				<button 
					className="menu-toggle" 
					onClick={toggleMenu} 
					aria-label="Toggle menu"
				>
					{isOpen ? <BsX /> : <BsList />}
				</button>

				<nav className={`nav-links ${isOpen ? "open" : ""}`}>
					<a href="#home" onClick={closeMenu}>Home</a>
					<a href="#about" onClick={closeMenu}>About</a>
					<a href="#experience" onClick={closeMenu}>Experience</a>
					<a href="#skills" onClick={closeMenu}>Skills</a>
					<a href="#education" onClick={closeMenu}>Education</a>
					<a href="#projects" onClick={closeMenu}>Projects</a>
					<a href="#certifications" onClick={closeMenu}>Certifications</a>
					<a href="#contact" onClick={closeMenu}>Contact</a>
					
					<div className="nav-actions-mobile">
						<button
							className="theme-toggle"
							onClick={() => { toggleTheme(); closeMenu(); }}
							aria-label="Toggle theme"
						>
							{isDarkMode ? <BsSun /> : <BsMoon />}
						</button>
						<a className="nav-resume btn-resume" href={profileData.resume} download onClick={closeMenu}>
							Download Resume
						</a>
					</div>
				</nav>

				<div className="nav-actions-desktop">
					<button
						className="theme-toggle"
						onClick={toggleTheme}
						aria-label="Toggle theme"
					>
						{isDarkMode ? <BsSun /> : <BsMoon />}
					</button>
					<a className="nav-resume" href={profileData.resume} download>
						Download Resume
					</a>
				</div>
			</div>
		</header>
	);
};

export default Navbar;
